module.exports = __webpack_public_path__ + "static/free-fall-feathers-c88a0ca3b2482f90ccb3857346290a04.png";